"use client";

import React from "react";
import { ArrowUp, Video, Instagram, Linkedin, Github } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const socialLinks = [{
  icon: Video,
  href: "#",
  label: "Video"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        {["How It Works", "What You Get", "Pricing", "Contact"].map((item, i) => <li key={i} data-index={i}>
            <Link to="#" className="text-sm text-muted-foreground transition-colors hover:text-primary">
              {item}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground transition-colors hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const currentYear = new Date().getFullYear();
  return <section data-section-id="264688" id="footer" className="bg-background text-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8 lg:gap-12">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="max-w-xs text-sm leading-relaxed text-muted-foreground font-default">
              We Find Your Hidden Hours.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-foreground">
              Navigation
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-foreground">
              Inquiries
            </h3>
            <div className="flex flex-col space-y-4">
              <Link to="mailto:hello@recouptime.com" className="text-sm text-muted-foreground transition-colors hover:text-primary font-default">recouptime@gmail.com<br /></Link>
              <p className="text-sm text-muted-foreground font-default">Salem, Oregon</p>
              <div className="flex gap-4">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="group flex size-10 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground transition-all duration-300 hover:border-primary hover:bg-primary/10 hover:text-primary hover:shadow-md">
                      <Icon className="size-4 transition-transform duration-300 group-hover:scale-110" />
                    </Link>;
              })}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col space-y-6">
          <Separator className="bg-border" />
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="text-sm text-muted-foreground font-default">
              © {currentYear} RecoupTime | <Link to="/RefundPolicyPage" className="text-xs text-muted-foreground hover:text-muted-foreground/70">Refund Policy</Link>. Premium AI Consulting.
            </p>
            <Button variant="ghost" size="icon" onClick={scrollToTop} aria-label="Back to top" className="rounded-lg text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary">
              <ArrowUp className="size-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}